import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { WmsOrderDetailDto, WmsOrderHeaderDto } from "src/dtos/wmsOrder/wmsOrderDto";
import { WmsTransportDetailDto, WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS1100_R01Dto {
	wmsOrderHeaderDto: WMS1100_R01HeaderDto;
	wmsOrderDetailDtoList: WMS1100_R01DetailDto[];
	
	wmsStockLotDtoList: Record<string, WMS1100_R01LotDto[]>;
}

export interface WMS1100_R01HeaderDto extends WmsTransportHeaderDto {
	transportCode: string;
}

export const defaultWMS1100_R01HeaderDto: WMS1100_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	transportDt: formatDate(new Date()),
	inoutType: '',
	inoutClass: '',
	customCd: '',
	customNm: '',
	otherLogicCenter: '',
	inoutMethod: '',
	empNo: '',
	empNm: '',
	transAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	trackingNo: '',
	approveFlg: '',
	remark: '',
	
	transportCode: '',

	inserted: false,
	isModified: false
}

// WMS 주문 상세 DTO (DetailBaseDto 요구사항 충족)
export interface WMS1100_R01DetailDto extends WmsTransportDetailDto {
}


export const defaultWMS1100_R01DetailDto: WMS1100_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	itemNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	transportDt: formatDate(new Date()),
	inoutType: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	unit: '',
	qty: 0,
	cost: 0,
	amt: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	inserted: false,
	isModified: false
}

export interface WMS1100_R01LotDto extends WmsStockLotDto {
	lotInputOption: string;
	printed: boolean;  // 라벨 출력 여부
}

export const defaultWMS1100_R01LotDto: WMS1100_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	lotInputOption: 'N',
	printed: false,  // 라벨 출력 여부 기본값

	inserted: false,
	isModified: false,
}
